import { ActionsUnion, createAction } from '../../../redux/customActions';
import { Popup } from '../../models/PopupModel';

export const Actions = {
    popupFetching: () => createAction('popup/popupRequested'),
    popupFailed: () => createAction('popup/popupRequestFailed'),
    popupRetrieved: (popup: Popup) => createAction('popup/popupReceived', { popup }),
};

export type ActionsType = ActionsUnion<typeof Actions>;
